// src/components/Categories.js
import styled from "styled-components";
import { Carcategory,RealEstateCategory } from "../data";
import CategoryItem from "./CategoryItem";

const Container = styled.div`
  display: flex;
  padding: 20px;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
`;

const Categories = ({ mode }) => {
  const data = mode === "realestate" ? RealEstateCategory : Carcategory;

  return (
    <Container>
      {data.map((item) => (
        <CategoryItem item={item} key={item.id} mode={mode} />
      ))}
    </Container>
  );
};

export default Categories;
